import * as Sentry from '@sentry/vue';
import { useToastStore } from '@/stores/toast';

/**
 * Composable for handling bug reports with Sentry
 */
export function useBugReport() {
  const toast = useToastStore();

  /**
   * Opens the Sentry bug report widget for user feedback
   */
  async function openSentryBugReportWidget() {
    // Get the instance returned by `feedbackIntegration()`
    const feedback = Sentry.getFeedback();
    if (!feedback) {
      toast.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Bug reporting is not available on localhost.',
        life: 5000,
      });
      return;
    }

    // Create form with user information
    const form = await feedback.createForm({
      showBranding: false,
      useSentryUser: {
        email: 'email',
        name: 'full_name',
      },
    });
    form.appendToDom();
    form.open();
  }

  return {
    openSentryBugReportWidget,
  };
}
